import { render } from "./Main.vue?vue&type=template&id=5945875b"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
script.render = render

export default script